import { OLAF } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITile from 'UIComponents/tile/UITile';
import { AllCombinedProductLines } from 'self-service-api/constants/AllCombinedProductLines';
import styled from 'styled-components';
import { WHY_GO_HUBSPOT_SECTION } from '../../../constants/ErrorBoundaryNames';
import { withErrorBoundary } from '../../../upgrade-page/ErrorBoundary';
import { Section, SectionTitle } from '../../common/SharedComponents';
import { borderStyle } from '../FreeToolsSharedComponents';
import ProductLineTile from './ProductLineTile';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WhyGoHubSpotContainer = styled(UITile).withConfig({
  displayName: "WhyGoHubSpotSection__WhyGoHubSpotContainer",
  componentId: "swcu30-0"
})(["border:none;"]);
const TitleSection = styled.div.withConfig({
  displayName: "WhyGoHubSpotSection__TitleSection",
  componentId: "swcu30-1"
})(["max-width:850px;margin:20px auto;text-align:center;"]);
const ProductLineTilesContainer = styled.div.withConfig({
  displayName: "WhyGoHubSpotSection__ProductLineTilesContainer",
  componentId: "swcu30-2"
})(["display:grid;grid-template-columns:1fr 1fr 1fr;grid-template-rows:1fr 1fr;grid-gap:15px;justify-items:center;max-width:1200px;margin:auto;"]);
const TileItemContainer = styled.div.withConfig({
  displayName: "WhyGoHubSpotSection__TileItemContainer",
  componentId: "swcu30-3"
})(["display:grid;width:100%;"]);
const WhyGoHubSpotSection = ({
  selectedNavItem
}) => {
  const productLineTileComponents = AllCombinedProductLines.map(productLine => {
    const commonStyles = {
      borderRight: borderStyle,
      borderLeft: borderStyle,
      backgroundColor: OLAF,
      width: '100%',
      textAlign: 'center',
      padding: '15px'
    };
    return /*#__PURE__*/_jsx(TileItemContainer, {
      children: /*#__PURE__*/_jsx(ProductLineTile, {
        commonStyles: commonStyles,
        productLine: productLine
      })
    }, productLine);
  });
  return /*#__PURE__*/_jsx(Section, {
    children: /*#__PURE__*/_jsxs(WhyGoHubSpotContainer, {
      children: [/*#__PURE__*/_jsxs(TitleSection, {
        children: [/*#__PURE__*/_jsx(SectionTitle, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `whyGoHubSpot.${selectedNavItem}.title`
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `whyGoHubSpot.${selectedNavItem}.subtitle`
          })
        })]
      }), /*#__PURE__*/_jsx(ProductLineTilesContainer, {
        children: productLineTileComponents
      })]
    })
  });
};
export default withErrorBoundary(WhyGoHubSpotSection, {
  boundaryName: WHY_GO_HUBSPOT_SECTION
});